import React from 'react'
// import classes from './styles.module.scss'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import { WhiteSpace } from 'antd-mobile'

export default class CardListEmpty extends React.Component {
  // constructor(props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }
  render() {
    const { type = 'payment' } = this.props
    return (
      <div className='text-center'>
        <img width='100' src={require('./card.png')} />
        <WhiteSpace size='lg' />
        <h3 className='font-md'>
          {type === 'withdraw' ? (
            <FormattedMessage {...messages.noAccountInfo} />
          ) : (
            <FormattedMessage {...messages.noCardInfo} />
          )}
        </h3>
        <p className='font-xs gray'>
          <FormattedMessage {...messages.subInfo} />
        </p>
      </div>
    )
  }
}
